import { EOfferStatus, IOfferState } from '../../types/reducers/offer';

export const offerDefaultState: Partial<IOfferState> = {
  id: null,
  status: EOfferStatus.draft,
  photos: [],
  multiposting: {
    enabled: false,
  },
  bargainTerms: {
    clientFee: null,
    agentFee: null,
    deposit: null,
    agentBonus: null,
  },
};
